import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors"; 

const ClassManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "120px",
    transition: "0.3s",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div className="flex justify-center items-start p-6 bg-white min-h-screen">
      <div className="w-full max-w-7xl">
        {/* Page Header */}
        
        {/* Grid */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>
          
          {/* Create Class */}
          <Link to="/create-class" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-plus-square" style={{ ...iconStyle, color: "purple" }}></i>
              <div>
                <h2 style={heading}>Create Class</h2>
                <p style={subText}>Create new classes.</p>
              </div>
            </div>
          </Link>

          {/* Create Section */}
          <Link to="/create-section" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-layer-group" style={{ ...iconStyle, color: "red" }}></i>
              <div>
                <h2 style={heading}>Create Section</h2>
                <p style={subText}>Create new sections.</p>
              </div>
            </div>
          </Link>

          {/* Subjects */}
          <Link to="/subject-management" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-book" style={{ ...iconStyle, color: "orange" }}></i>
              <div>
                <h2 style={heading}>Subjects</h2>
                <p style={subText}>Manage subjects and curriculum details.</p>
              </div>
            </div>
          </Link>

          {/* School Timing */}
          <Link to="/school-timing" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-clock" style={{ ...iconStyle, color: "gray" }}></i>
              <div>
                <h2 style={heading}>School Timing</h2>
                <p style={subText}>Manage the time schedule of school.</p>
              </div>
            </div>
          </Link>

          {/* Manage Timetable */}
          <Link to="/manage-timetable" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-calendar-alt" style={{ ...iconStyle, color: colors.primary }}></i>
              <div>
                <h2 style={heading}>Manage Timetable</h2>
                <p style={subText}>Manage class timetables.</p>
              </div>
            </div>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default ClassManagement;
